<template>
  <div class="history-detail-page">
    <van-nav-bar
      title="详情页"
      left-text="返回"
      left-arrow
      right-text="主页"
      @click-right="handleHome"
      @click-left="onClickLeft"
    />
    <div class="content">
      <van-row class="Bar">
        <span>意见详情</span>
      </van-row>
      <van-cell-group>
        <van-cell title="联络站名称" :value="list.llzname" />
        <van-cell title="代表姓名" :value="list.dbname" />
        <van-cell title="所属地区" :value="area" />
        <van-cell title="联系人姓名" :value="list.lxrxm" />
        <van-cell title="联系方式" :value="list.lxfs" />
        <van-cell title="联系时间" :value="list.lxsj" />
        <van-cell title="意见内容" :label="list.yjnr"/>
      </van-cell-group>
      <div class="img-bar">
        <img class="link-bar" v-for="(file, index) in files" :key="file.id" :src="file.url" @click="openImage(index)"/>
        <van-image-preview v-model="show" :images="images"></van-image-preview>
      </div>
      <van-row class="Bar" v-if="!list.llzdfnr && !list.dbdfnr">
        <span>意见答复情况</span>
      </van-row>
      <div class="card" v-if="list.dbdfnr">
        <div class="bldw">
          <span>答复代表:{{ list.dbname }}</span>
          <span>答复时间:{{ list.dbdfsj }}</span>
        </div>
        <div class="con">{{ list.dbdfnr }}</div>
      </div>
      <div class="card" v-if="list.llzdfnr">
        <div class="bldw">
          <span>联络站答复人:{{ list.dbname }}</span>
          <span>答复时间:{{ list.llzdfsj }}</span>
        </div>
        <div class="con">{{ list.llzdfnr }}</div>
      </div>
      <div class="card" v-if="list.sptdfnr">
        <div class="bldw">
          <span>答复单位：四平台</span>
          <span>答复时间：{{ list.sptdfsj }}</span>
        </div>
        <div class="con">{{ list.sptdfnr }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/api/getLLZ'
import { ImagePreview } from 'vant'
export default {
  data () {
    return {
      show: false,
      id: '',
      list: {},
      area: '',
      files: [],
      images: []
    }
  },
  created () {
    this.id = this.$route.query.id
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    openImage (index) {
      const images = this.images
      ImagePreview({
        images,
        startPosition: index
      })
    },
    onClickLeft () {
      this.$router.back(-1)
    },
    handleHome () {
      this.$router.push('/home')
    },
    getDetail () {
      const url = this.$api
      request.contextDetail(this.id)
        .then((res) => {
          this.list = res
          this.area = res.ssqx + '-' + res.ssxzjd
          const files = res.files.split(',')
          const filesname = res.filesName.split(',')
          this.files = files.map((m, index) => ({
            filesid: m,
            filesname: filesname[index],
            url: url + m
          }))
          this.images = this.files.map(m => m.url)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>
<style lang="less" scoped>
.history-detail-page{
  .content{
    padding: 20px;
    background-color: rgba(200, 200, 200, 0.3);
  }
}
.files {
  color: rgb(35, 153, 255);
}
.Bar {
  background: rgb(25, 137, 250);
  display: flex;
  align-items: center;
  font-size: 34px;
  color: #fff;
  height: 80px;
  border-radius: 10px;
  > span {
    padding-left: 20px;
    font-weight: 500;
    letter-spacing: 2px;
  }
}
.card {
  position: relative;
  border: 1px solid #c8c8c8;
  margin: 20px 10px 40px 10px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 3px 5px 0 rgba(0, 0, 0, 0.1);
  .bldw {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    font-size: 28px;
    margin: 40px 0 20px 0;
    padding: 0 30px;
    span {
      margin: 20px 0;
    }
  }
  .con {
    font-size: 28px;
    margin: 20px 0;
    padding: 0 30px;
  }
}
.img-bar{
  padding: 0 22px;
  padding-bottom: 20px;
  display: flex;
  gap: 20px;
  justify-content:flex-start;
  margin-bottom: 20px;
  background-color: #fff;
  img{
    width: 30%;
  }
}
/deep/ .van-cell{
  padding: 20px;
}
/deep/ .van-cell__label{
  font-size: 32px;
  text-align: justify;
}
</style>
